import React from 'react';
export const AboutSection = () => {
  return <section className="py-24 border-t border-gray-100 relative" id="about-section" data-id="element-42">
      <div className="max-w-4xl mx-auto" data-id="element-43">
        <h2 className="font-serif text-4xl font-bold text-center mb-12" data-id="element-44">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-45">
            Who We Are
          </span>
        </h2>
        <div className="bg-white p-10 rounded-xl shadow-md border border-gray-100 mb-12 transition-all hover:shadow-lg" data-id="element-46">
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-47">
            Creator Boost is built by software experts designing AI-powered
            infrastructure for creators. We help you monetize and grow by
            automating recommendation workflows, surfacing opportunities, and
            building future tools so you stay relevant and profitable in an
            AI-first creator economy.
          </p>
          <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-500" data-id="element-48">
            <h3 className="font-medium text-xl mb-2" data-id="element-49">Why it matters</h3>
            <p className="text-gray-700" data-id="element-50">
              AI turns your existing influence into scalable income, without
              extra busywork.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-51">
          {[{
          title: 'Expert Team',
          value: 'Built by AI & creator economy experts'
        }, {
          title: 'Proven Results',
          value: 'Helping creators boost revenue'
        }, {
          title: 'Future-Ready',
          value: 'Stay ahead of AI disruption in content'
        }].map((item, index) => <div key={index} className="bg-white p-7 rounded-xl shadow-md border border-gray-100 text-center transition-all hover:shadow-lg hover:-translate-y-1" data-id="element-52">
              <h3 className="font-medium text-lg mb-3 text-blue-600" data-id="element-53">
                {item.title}
              </h3>
              <p className="text-gray-700" data-id="element-54">{item.value}</p>
            </div>)}
        </div>
      </div>
    </section>;
};